export default __webpack_public_path__ + "static/media/descargacfdi_plus.af59c41b.svg";